import React from 'react';
import CenteredContent from '../components/CenteredContent';
import ImageSpryDispatch from '../imgs/sprydispatch.png'
import { FaHorseHead } from 'react-icons/fa';

function PortfolioPage() {
  return (
    <div>
        <CenteredContent>
            <h1>Portfolio</h1>

            <p>I've founded and developed several online companies, including:</p>

              {/* Spry Dispatch */}

              <a href="https://www.sprydispatch.com">
                <h2><FaHorseHead size={32} style={{ color: '#5F4DEE' }}/> Spry Dispatch</h2>
              </a>
              <p>
                Spry Dispatch is a dispatching software for service companies. It allows service companies to manage their jobs, field technicians, and customers. It has a mobile app on iOS and Android for field technicians to manage their jobs and a web app for office staff to manage the company.
              </p>
              <p>
                <strong>Role:</strong> Founder, Developer.
              </p>
              <p>
                <strong>Founded:</strong> March 2022.
              </p>
              <p>
                <strong>URL:</strong> <a href="https://www.sprydispatch.com">www.sprydispatch.com</a>.
              </p>
              <p>
                <strong>Tools:</strong> Django, React, React Native mobile development (Android and iOS), Google Maps API, Stripe.
              </p>
              <p>
                <a href="https://www.sprydispatch.com">
                  <img src={ImageSpryDispatch} alt="Talk To Files landing page" style={{ width: '100%', height: '25%', marginRight: '10px' }} />
                </a>
              </p>
        </CenteredContent>
      {/* Add your content */}
    </div>
  );
}

export default PortfolioPage;
